import { useState, useEffect, useCallback } from 'react';
import StoreCashModal from '../UI/StoreCashModal';

const SubText = ({ text, widgetModals }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const modalHtml = Object.values(widgetModals)[0].Modal_Html;

  const toggleModal = useCallback((e) => {
    e.preventDefault();
    setModalOpen(!isModalOpen);
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = ''; 
    }

    // Clean up the style on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [isModalOpen]);

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 100;

    const checkElement = () => {
      const triggerElement = document.getElementById('storecashModalTrigger');
      if (triggerElement) {
        triggerElement.addEventListener('click', toggleModal);
      } else if (attempts < maxAttempts) {
        // If the element is not found yet and we haven't exceeded max attempts, try again after a delay
        attempts++;
        setTimeout(checkElement, 100);
      }
    };

    checkElement();

    return () => {
      const triggerElement = document.getElementById('storecashModalTrigger');
      if (triggerElement) {
        triggerElement.removeEventListener('click', toggleModal);
      }
    };
  }, [toggleModal]);

  return (
    <>
      <div className="text-size-75 storecash__subtext" dangerouslySetInnerHTML={{ __html: text }} />
      {isModalOpen && (
        <StoreCashModal onClose={toggleModal} isOpen={isModalOpen}>
          <div dangerouslySetInnerHTML={{ __html: modalHtml }} />
        </StoreCashModal>
      )}
    </>
  );
};

export default SubText;
